<template>
  <b-card class="border rounded-xl border-gray-200 mb-3">
    <div class="flex items-center justify-between">
      <div>
        <h5 class="text-base font-semibold text-[#333333] mb-0.5">
          Notifikasi Email
        </h5>
        <p class="text-xs md:text-sm text-[#828282] mb-0">
          Atur subsidi ongkir dengan lebih baik dan efisien.
        </p>
      </div>
      <b-form-checkbox
        id="checkbox-email-close-order"
        v-model="formData.email_close_order"
        switch
        class="custom-cs-switch mb-0"
      />
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
}
</script>
